import { render, staticRenderFns } from "./reserve_project_detail.vue?vue&type=template&id=5b2d5bb1&scoped=true"
import script from "./reserve_project_detail.vue?vue&type=script&lang=js"
export * from "./reserve_project_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d5bb1",
  null
  
)

export default component.exports